export function stringifyFilters(filters) {
  if (!filters || Object.keys(filters).length === 0) return "";
  const fDataByType = (fData) => {
    const strFData = fData.map(({ value }) => value).join(",");
    return fData[0].type === "string" ? `'${strFData}'` : strFData;
  };
  return Object.entries(filters).map(([column, fData]) => `${column}:${fDataByType(fData)}`).join(";");
}
function isDate(value) {
  return !Number.isNaN(Date.parse(value));
}
function buildDateQuery(from, to) {
  const fromDate = new Date(from).toISOString().replace("T", " ").replace(/Z$/, "");
  const toDate = to ? new Date(to).toISOString().replace("T", " ").replace(/Z$/, "") : new Date(new Date(from).getTime() + 24 * 60 * 60 * 1e3).toISOString().replace("T", " ").replace(/Z$/, "");
  return `["${fromDate}" TO "${toDate}"]`;
}
export function buildOpenSearchQuery(filters) {
  const query = Object.entries(filters).map(([column, fData]) => {
    var _a;
    const strFData = fData.every(({ value, type }) => isDate(value) && type === "date") ? buildDateQuery(fData[0].value, (_a = fData[1]) == null ? void 0 : _a.value) : `(${fData.map(({ value, type }) => type === "number" ? `${value}` : `"${value}"`).join(" OR ")})`;
    return `${column}:${strFData}`;
  }).join(" AND ");
  return query;
}
